import { Button, ButtonProps } from "@mui/material";
import { useStylesCss } from "./AppButtons.styles";

const FlowBackButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  const classes = useStylesCss();
  const myClasses = { ...props.sx, ...classes.general };
  const myProps = {
    sx: myClasses,
    ...props,
  };
  return (
    <Button variant="contained" {...myProps} color="secondary">
      {props.children}
    </Button>
  );
};
export default FlowBackButton;
